import classNames from 'classnames';
import React from 'react';
import CodeSparkThemedTypography from '../CodeSparkThemedTypography';
import styles from './ImageTextCard.module.css';

export const CardImage = ({ className, src, alt }) => (
  <div className={classNames(styles.imageTextCardImage, className)}>
    <img src={src} alt={alt} />
  </div>
);

export const CardContent = ({ children, className }) => (
  <div className={classNames(styles.imageTextCardContent, className)}>{children}</div>
);

export const CardTitle = ({ children, className, ...props }) => (
  <CodeSparkThemedTypography
    variant="h4"
    className={classNames(styles.imageTextCardTitle, className)}
    {...props}
  >
    {children}
  </CodeSparkThemedTypography>
);

export const CardBody = ({ children, className, ...props }) => (
  <CodeSparkThemedTypography
    variant="body2"
    className={classNames(styles.imageTextCardBody, className)}
    {...props}
  >
    {children}
  </CodeSparkThemedTypography>
);

export const ImageTextCard = ({ children, className }) => {
  return (
    <div className={classNames(`cell medium-12 large-4 ${styles.imageTextCard}`, className)}>
      {children}
    </div>
  );
};

export default ImageTextCard;



// WEBPACK FOOTER //
// ./src/components/elements/ImageTextCard/index.js